import React from 'react'
import { connect } from 'react-redux';
import classes from './HomePage.module.scss';
import { localization } from '../../../../Utils/Localization/localization';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';

interface StateProps {
  language: string
}
interface DispatchProps { }
interface Props extends StateProps, DispatchProps { }

function HomePage(props: Props) {
  return (
    <div className={classes.HomePage}>
      <h2>Home page</h2>
      <p>{localization('homeDescription', props.language)}</p>
      <ul>
        <li>
          <h3>{localization('products', props.language)}</h3>
          <ul>
            <li>{localization('addOrDeleteProducts', props.language)}</li>
            <li>{localization('editProducts', props.language)}</li>
          </ul>
        </li>
        <li>
          <h3>{localization('categories', props.language)}</h3>
          <ul>
            <li>{localization('addOrDeleteCategories', props.language)}</li>
            <li>{localization('editCategories', props.language)}</li>
          </ul>
        </li>
        <li>
          <h3>{localization('reports', props.language)}</h3>
          <ul>
            <li>{localization('seeReports', props.language)}</li>
          </ul>
        </li>
        <li>
          <h3>{localization('orders', props.language)}</h3>
          <ul>
            <li>{localization('seeOrders', props.language)}</li>
            <li>{localization('cancelOrders', props.language)}</li>
          </ul>
        </li>

      </ul>
    </div>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state)
  }
}
const mapDispatchToProps = {}

const ConnectedHomePage = connect(mapStateToProps, mapDispatchToProps)(HomePage);
export { ConnectedHomePage as HomePage };